import React from 'react'

export function IconFichaNovaComponent({ fill = '#2F5DC9', height = '17', width = '17' }: { fill?: string, height?: string, width?: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill={fill} viewBox="0 0 116 116">
      <path fill={fill} d="M48.333 19.334L58 29.001h38.667c2.564 0 5.022 1.018 6.835 2.831 1.813 1.813 2.831 4.272 2.831 6.835v48.334c0 2.563-1.018 5.022-2.831 6.835-1.813 1.813-4.271 2.831-6.835 2.831H19.333c-2.563 0-5.022-1.018-6.835-2.831-1.813-1.813-2.831-4.272-2.831-6.835V29c0-5.365 4.301-9.667 9.666-9.667h29zM72.5 43.501V58H58v9.666h14.5v14.5h9.667v-14.5h14.5v-9.666h-14.5V43.5H72.5z" />
    </svg>
  )
}
